import React from 'react';
import AppContainer from '../app-container';
import DocumentTitle from 'react-document-title';
import {isEnglish} from '../../localization/language-cookie';

export default class InsurancePageContainer extends AppContainer {
  getContent() {
      return isEnglish()
          ? window.CARE_CONFIG.settings.insurance_text_en
          : window.CARE_CONFIG.settings.insurance_text;
  }

  getTitle(){
    return isEnglish()
        ? window.CARE_CONFIG.settings.insurance_text_label_en
        : window.CARE_CONFIG.settings.insurance_text_label;
  }

    render() {
        return (
            <DocumentTitle title={this.getDocumentTitle(this.getTitle())}>
                <div className="page-section">
                    <div className="container">
                        <h3 className="title">
                            <span dangerouslySetInnerHTML={{
                                __html: this.getTitle()
                            }}></span>
                        </h3>
                        <div className="post-body" dangerouslySetInnerHTML={{
                            __html: this.getContent()
                        }}></div>
                    </div>
                </div>
            </DocumentTitle>
        )
    }
}



// WEBPACK FOOTER //
// ./src/js/containers/pages/insurance-page-container.js